import {
  verifyTypes,
  verifyData,
  verifyResultsDefaultErrorText
} from '@/cllib/verify'

import {
  fMuuid
} from '@/cllib/tools'

import router from '@/router'

import {
  saveData
} from '@/cllib/local_storage'

import {
  login,
  userGetSalt
} from '@/api/api'

import sysEnv from '@/env/envs'

let md5 = require('js-md5')

const loginFormVerifyParm = {
  account: {
    needDataType: verifyTypes.STRING,
    minLength: 1,
    required: true
  },
  password: {
    needDataType: verifyTypes.STRING,
    minLength: 1,
    required: true
  },
  verificationCode: {
    needDataType: verifyTypes.STRING,
    minLength: 1,
    required: true
  }
}

const state = {
  loginForm: {
    account: '',
    password: '',
    remember: true,
    verificationCode: ''
  },
  loginFormVerification: {
    account: {
      pass: 0,
      error: ''
    },
    password: {
      pass: 0,
      error: ''
    },
    verificationCode: {
      pass: 0,
      error: ''
    },
    allPass: false
  },
  pwdUuid: null,
  loginLoading: false,
  reSetPassword: false,
  reSetPasswordToken: null
}

const getters = {
  loginForm: state => state.loginForm,
  loginFormVerification: state => state.loginFormVerification,
  loginLoading: state => state.loginLoading,
  reSetPassword: state => state.reSetPassword,
  pwdUuid: state => state.pwdUuid,
  reSetPasswordToken: state => state.reSetPasswordToken,
  verifyCodeImgSrc: (state) => {
    return state.pwdUuid ? sysEnv.apiAdr + '/ucenter/oauth/verify/code?key=' + state.pwdUuid : ''
  }
}

const actions = {
  setLoginFormAccount ({ commit }, data) {
    commit('setLoginFormAccount', data)
    commit('verifyLoginForm', 'account')
  },
  setLoginFormPassword ({ commit }, data) {
    commit('setLoginFormPassword', data)
    commit('verifyLoginForm', 'password')
  },
  setLoginFormVerificationCode ({ commit }, data) {
    commit('setLoginFormVerificationCode', data)
    commit('verifyLoginForm', 'verificationCode')
  },
  setLoginFormRemember ({ commit }, data) {
    commit('setLoginFormRemember', data)
  },
  setReSetPasswordToken ({ commit }, data) {
    commit('setReSetPasswordToken', data)
  },
  setReSetPassword ({ commit }, data) {
    commit('setReSetPassword', data)
  },
  setReSetPasswordReceipt ({ commit }, data) {
    commit('setReSetPasswordReceipt', data)
  },
  updatePwdUuid ({ commit }) {
    commit('setPwdUuid', fMuuid())
  },
  setLoginLoading ({ commit }, data) {
    commit('setLoginLoading', data)
  },
  async login ({ dispatch, getters }) {
    if (!getters.pwdUuid) {
      dispatch('showNoticeMsg', {type: 'warning', title: '系统提示', message: '请刷新页面重新登录。'})
      return
    }
    dispatch('setLoginLoading', true)
    let pwdSalt = ''
    try {
      let parm = {
        key: getters.pwdUuid
      }
      pwdSalt = await userGetSalt(parm)
    } catch (error) {
      dispatch('showNoticeMsg', {type: 'warning', title: '系统提示', message: '获取盐值失败，请联系管理员。'})
      dispatch('setLoginLoading', false)
      return error
    }
    let parm = {
      phone: getters.loginForm.account,
      password: md5(md5(getters.loginForm.password) + pwdSalt),
      verifyCode: getters.loginForm.verificationCode,
      verifyCodeKey: getters.pwdUuid,
      saltKey: getters.pwdUuid,
      clientType: 'web'
    }
    return login(parm).then((data) => {
      dispatch('setLoginLoading', false)
      if (data.token) {
        saveData({key: 'token', data: data.token})
        router.push({name: 'auth'})
      } else {
        dispatch('showNoticeMsg', {type: 'warning', title: '系统提示', message: '需要修改密码后才能登录!'})
        dispatch('setReSetPasswordToken', data.receipt)
        dispatch('setReSetPassword', true)
      }
    }).catch(() => {
      dispatch('setLoginLoading', false)
      dispatch('updatePwdUuid')
    })
  }
}

const mutations = {
  setLoginFormAccount (state, data) {
    state.loginForm.account = data
  },
  setReSetPasswordToken (state, data) {
    state.reSetPasswordToken = data
  },
  setReSetPassword (state, data) {
    state.reSetPassword = data
  },
  setLoginLoading (state, data) {
    state.loginLoading = data
  },
  setPwdUuid (state, data) {
    state.pwdUuid = data
  },
  verifyLoginForm (state, key) {
    let verifyResult = verifyData(state.loginForm[key], loginFormVerifyParm[key])
    state.loginFormVerification[key] = {
      pass: verifyResult === 'pass' ? 1 : -1,
      error: verifyResultsDefaultErrorText[verifyResult]
    }
    let allPass = true
    for (let key in state.loginFormVerification) {
      if (key !== 'allPass' && state.loginFormVerification[key].pass !== 1) {
        allPass = false
      }
    }
    state.loginFormVerification.allPass = allPass
  },
  setLoginFormPassword (state, data) {
    state.loginForm.password = data
  },
  setLoginFormVerificationCode (state, data) {
    state.loginForm.verificationCode = data
  },
  setLoginFormRemember (state, data) {
    state.loginForm.remember = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/account/login.js